import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  DeleteTaskMutation,
  DeleteTaskMutationVariables,
  DeleteTaskDocument,
  FetchTasksByTenderIdDocument,
} from "@/graphql/__generated__/graphql";

export default function useDeleteTaskMutationHook(): {
  deleteTaskMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [deleteTaskMutation, { loading, error }] = useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(
    DeleteTaskDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "task-deleted-success",
          data: {
            title: t("toasts.taskdeleted"),
            type: "success",
          },
        });
      },
      refetchQueries: [
        {
          query: FetchTasksByTenderIdDocument,
          variables: { tenderId: Number(tenderID) },
        },
      ],
    });

  return {
    deleteTaskMutation,
    loading,
    error,
  };
}
